import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./css/infistaking.css";

export default function InfiLaunchpad() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const sendToLaunchpad = () => {
    navigate(`${config.baseUrl}launchpad`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="infiLaunchpad position-relative pt-5 pb-0 overflow-hidden">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={8}>
              <div className="">
                <Card className=" bg-transparent border-0">
                  <Card.Body>
                    <div className=" position-relative mb-5">
                      <div className="position-relative d-inline-block text-left">
                        <h1 className=" text-white lh-sm mb-4">
                          <span className="position-relative z-1">
                            INFI Launchpad{" "}
                            <span className="fw-normal">
                              – Empowering the Next Generation of Decentralized Crypto
                              Projects
                            </span>
                          </span>
                          <div className="polygon" style={{ right: "-120px" }}>
                            <img src="images/shape/polygon.png" alt="" style={{ width: "208px" }} />
                          </div>
                        </h1>

                        {/* <h1 className="text-white lh-sm mb-4">
                        INFI Launchpad{" "}
                        <span className="fw-normal">
                          – Powering the Next Generation of Crypto Projects
                        </span>
                      </h1> */}
                        <div className="position-relative">
                          <ul className="ps-0 list-unstyled mb-4">
                            <li className="mb-3 text-light-grey2">
                              🔹{" "}
                              <span className="text-white">
                                Multi-Chain Compatibility
                              </span>{" "}
                              – Access project token distributions across supported blockchains
                              via smart contracts.
                            </li>
                            <li className="mb-3 text-light-grey2">
                              🔹{" "}
                              <span className="text-white">
                                Autonomous Liquidity Management
                                (SpecialLM)
                              </span>{" "}
                              - Liquidity logistics are fully
                              automated and optimized by the ©SbSe
                              Protocol’s SpecialLM system — with no manual
                              handling or centralized custody.
                            </li>
                            <li className="mb-3 text-light-grey2">
                              🔹{" "}
                              <span className="text-white">Decentralized Listing Security</span>{" "}
                              - Smart
                              contract–based liquidity locks and protections are
                              enforced autonomously by the SbSe Protocol,
                              ensuring tamper-resistant project onboarding.
                            </li>
                            <li className="mb-3 text-light-grey2">
                              🔹{" "}
                              <span className="text-white">
                                Protocol-Level Safeguard Window
                              </span>{" "}
                              - The
                              SbSe Reserve operates a community-backed,
                              time-bound dispute mechanism (48-hour response
                              window) managed entirely on-chain, offering
                              participants added transparency — not guaranteed
                              compensation.
                            </li>
                          </ul>
                          <Button
                            variant="white-gradient"
                            className="me-3 px-5 rounded-5"
                            onClick={sendToLaunchpad}
                          >
                            DISCOVER MORE&nbsp;&nbsp;
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7921 1.08813L22.6729 9.21992M22.6729 9.21992L15.7921 17.3517M22.6729 9.21992L1.3269 9.21992"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
            <Col lg={4}>
              <div className="position-relative">
                <img src="images/coincircle.png" className="w-100 coingif" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
